import type React from "react";
import { ThemeToggle } from "../../context/ThemeContext";
import { WIZARD_STEPS } from "../../types/onboarding";
import StepIndicator from "./StepIndicator";

interface OnboardingLayoutProps {
	currentStep: number;
	children: React.ReactNode;
}

const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
	currentStep,
	children,
}) => {
	return (
		<div
			style={{
				minHeight: "100vh",
				background: "var(--color-bg-primary)",
				display: "flex",
				flexDirection: "column",
			}}
		>
			{/* Top bar */}
			<header
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					padding: "1rem 2rem",
					borderBottom: "1px solid var(--color-border)",
					background: "var(--color-white)",
				}}
			>
				<div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
					<span
						style={{
							fontSize: "1.25rem",
							fontWeight: 700,
							color: "var(--color-text-primary)",
							letterSpacing: "-0.02em",
						}}
					>
						MoneyGram
					</span>
					<span
						style={{
							fontSize: "0.75rem",
							color: "var(--color-text-secondary)",
							borderLeft: "1px solid var(--color-border)",
							paddingLeft: "0.5rem",
							marginLeft: "0.25rem",
						}}
					>
						Wallet Onboarding
					</span>
				</div>
				<ThemeToggle />
			</header>

			{/* Step Indicator */}
			<div
				style={{
					maxWidth: "48rem",
					width: "100%",
					margin: "1.5rem auto 0",
					padding: "0 1rem",
				}}
			>
				<StepIndicator
					currentStep={currentStep}
					totalSteps={WIZARD_STEPS.length}
					stepLabels={WIZARD_STEPS.map((s) => s.label)}
				/>
			</div>

			{/* Main content */}
			<main
				style={{
					flex: 1,
					maxWidth: "48rem",
					width: "100%",
					margin: "0 auto",
					padding: "2rem 1rem",
				}}
			>
				{children}
			</main>

			{/* Footer */}
			<footer
				style={{
					textAlign: "center",
					padding: "1rem 2rem",
					borderTop: "1px solid var(--color-border)",
					color: "var(--color-text-secondary)",
					fontSize: "0.75rem",
				}}
			>
				&copy; {new Date().getFullYear()} MoneyGram. All rights reserved.
			</footer>
		</div>
	);
};

export default OnboardingLayout;
